module.exports = __webpack_public_path__ + "static/media/clearpassblue.4cab52c9.png";